import React, { useState, useEffect } from "react";
import "./stat.styles.scss";
import { connect } from "react-redux";
import axios from "axios";
import Illustrator from "../../../assets/images/illustrate-4.svg";
import IllustratorSix from "../../../assets/images/illustrate-6.svg";
import { store } from '../../../redux-store/store';


export const StatComponent = ({
  firstName,
  users,
  locations,
  products,
  productCategories,
  companyName,
}) => {

  console.log('Here are your locations --- ',locations)
  return (
    <>
      <div className="container">
        <div
          className="container-fluid welcome-head text-white mt-4 p-4 row"
          style={{ border: "1px solid #d8dbe0" }}
        >
          <div className="col">
            <h2>
              Hi, <strong>{firstName}</strong>
            </h2>
            <p>
              Welcome to <strong>{companyName}'s store</strong>{" "}
              dashboard{" "}
            </p>
            <p>
              Pick up from were you left your <strong>inventory</strong>
            </p>
          </div>
          <div className="col row">
            <div className="img-container d-flex float-right col">
              <img src={IllustratorSix} alt="" width="80%" />
            </div>
            <div className="img-container d-flex float-right col">
              <img src={Illustrator} alt="" width="80%" />
            </div>
          </div>
        </div>

        <div className="container-fluid mt-3">
          <div className="row">
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white homeCard mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className="text-primary m-0">
                    {" "}
                    <strong> No of Users</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {users} </strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className="m-0 text-primary">
                    {" "}
                    <strong> No of Locations</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong>{locations.length}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className="m-0 text-primary">
                    {" "}
                    <strong> No of Products</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {products}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className=" m-0 text-primary">
                    {" "}
                    <strong> Product Categories</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {productCategories}</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white homeCard mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className="text-primary m-0">
                    {" "}
                    <strong> Inventory Value</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {localStorage.getItem("inventoryValue")} </strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className="m-0 text-primary">
                    {" "}
                    <strong>Retail Value</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {localStorage.getItem("retailValue")}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className="m-0 text-primary">
                    {" "}
                    <strong> Potential Profit</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {localStorage.getItem("potentialProfit")}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className=" m-0 text-primary">
                    {" "}
                    <strong>Potential GM%</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {localStorage.getItem("grossMargin")}</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white homeCard mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className="text-primary m-0">
                    {" "}
                    <strong> Sales YTD</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {localStorage.getItem("salesYearToDate")} </strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className="m-0 text-primary">
                    {" "}
                    <strong>Sales MTD</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {localStorage.getItem("salesMonthToDate")}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className="m-0 text-primary">
                    {" "}
                    <strong>Sales WTD</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {localStorage.getItem("salesWeekToDate")}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className=" m-0 text-primary">
                    {" "}
                    <strong>Today Sales</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {localStorage.getItem("salesToday")}</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* </div> */}
        </div>
      </div>
    </>
  );
};

function mapStateToProps(state) {
  return {
    firstName: state.userReducer.firstName,
    users: state.userReducer.users,
    locations: state.locationReducer.locations,
    companyName: state.persistReducer.companyName,
    products: state.persistReducer.products,
    productCategories: state.persistReducer.productCategories,
  };
}
const mapDispatchToProps = (dispatch) => ({
  UpdateUser(payload) {
    dispatch({ type: "UPDATE_USER", payload });
  },
  LoadUsers(payload) {
    dispatch({ type: "LOAD_USERS", payload });
  },
  AddUser(payload) {
    dispatch({ type: "ADD_USER", payload });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(StatComponent);
